// extracted by mini-css-extract-plugin
module.exports = {"box_notification":"_3I7SGbnPrkWFbvfpSb4_oD"};